import * as React from "react";
import {
  Message,
  MessageText,
  MessageButtons,
  MessageButton,
  MessageTitle,
  MessageMedia,
  QuickReplies,
  QuickReply,
  Bubble
} from "@livechat/ui-kit";
import anchorme from "anchorme";

function ShowHtml(body) {
  return <div dangerouslySetInnerHTML={{ __html: body }} />;
}

const styles = {
  img: {
    width: 190,
    height: 150,
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }
};

export class ComposedMessage extends React.Component {
  state = {
    isQuickRepliesHidden: false
  };

  render() {
    const {
      message,
      ownId,
      sendMessage,
      style,
      bubbleStyle,
      isLastMsg
    } = this.props;
    const { isQuickRepliesHidden } = this.state;

    return (
      <Message
        style={style}
        key={message.id}
        isOwn={message.authorId === ownId || message.own === true}
      >
        <Bubble
          isOwn={message.authorId === ownId || message.own === true}
          style={bubbleStyle}
        >
          {message.imageUrl && (
            <MessageMedia style={styles.img}>
              <img src={message.imageUrl} />
            </MessageMedia>
          )}
          {message.title && (
            <MessageTitle style={{ textAlign: "center", height: 37 }}>
              {ShowHtml(message.title.replace("CAROUSEL:", ""))}
            </MessageTitle>
          )}
          {message.text && (
            <MessageText style={{ overflowWrap: "normal" }}>
              {ShowHtml(anchorme(message.text.replace("CAROUSEL:", "")))}
            </MessageText>
          )}
          {message.buttons && message.buttons.length !== 0 && (
            <MessageButtons>
              {message.buttons.map((button, buttonIndex) => (
                <MessageButton
                  key={buttonIndex}
                  label={button.title.replace("<br>", "\r\n")}
                  onClick={() => {
                    if (button.type == "web_url") {
                      window.open(button.url);
                    } else {
                      sendMessage(button.title, button.postback);
                    }
                  }}
                />
              ))}
            </MessageButtons>
          )}
          {!isQuickRepliesHidden &&
            isLastMsg &&
            message.replies &&
            message.replies.length !== 0 && (
              <QuickReplies>
                {message.replies.map((button, buttonIndex) => (
                  <QuickReply
                    key={buttonIndex}
                    children={button.title.replace("<br>", "\r\n")}
                    onClick={() => {
                      sendMessage(button.title, button.postback);
                      this.setState({
                        isQuickRepliesHidden: true
                      });
                    }}
                  />
                ))}
              </QuickReplies>
            )}
        </Bubble>
      </Message>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ComposedMessage.js